module.exports = __webpack_public_path__ + "static/media/sanitaria-03.5334db56.jpg";